import { render, staticRenderFns } from "./item-info-approved.vue?vue&type=template&id=4f18a667&scoped=true&"
import script from "./item-info-approved.vue?vue&type=script&lang=js&"
export * from "./item-info-approved.vue?vue&type=script&lang=js&"
import style0 from "./item-info-approved.vue?vue&type=style&index=0&id=4f18a667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f18a667",
  null
  
)

export default component.exports